import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { customerService } from "../../services/CustomerService";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { InputNumber } from "primereact/inputnumber";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { InputMask } from "primereact/inputmask";
import { Card } from "primereact/card";
import { SelectButton } from "primereact/selectbutton";
import { Toast } from "primereact/toast";
import CustomerAddressSection from "../../components/CustomerAddressSection";

export default function CustomerEditPage() {
    const [mounted, setMounted] = useState(false);
    useEffect(() => { setMounted(true); }, []);
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useRef(null);

  const [loading, setLoading] = useState(true);
  const [customer, setCustomer] = useState({
    name: "",
    email: "",
    phone: "",
    authorizedPerson: "",
    address: "",
    otherInfo: "",
    taxOffice: "",
    taxNumber: "",
    isTaxExempt: false,
    bankInfo: "",
    fixedDiscountRate: null,
    openingBalance: null,
    note: "",
    isActive: true
  });

  const [address, setAddress] = useState({
  ilId: null,
  ilceId: null,
  koyId: null,
});

  const [customerType, setCustomerType] = useState(1);
  const typeOptions = [
    { label: 'Bireysel', value:  1, icon: 'pi pi-user' },
    { label: 'Kurumsal', value: 2, icon: 'pi pi-building' }
  ];

  const handleChange = (field, value) => {
    setCustomer({ ...customer, [field]: value });
  };

  const loadData = async () => {
    try {
      const res = await customerService.getById(id);
      const data = res.data.data;
      setCustomer(data);
      setAddress({
      ilId: data.provinceId ?? null,
      ilceId: data.districtId ?? null,
      koyId: data.villageId ?? null
    });

      // Determine type based on tax office presence or tax number length
      if (data.taxOffice || (data.taxNumber && data.taxNumber.length === 10)) {
         setCustomerType(2); 
      } else {
         setCustomerType(1);
      }

      setLoading(false);
    } catch (err) {
      console.error(err);
      toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Müşteri verileri yüklenemedi', life: 3000 });
    }
  };

  const handleSave = async () => {
    const payload = {
  ...customer,
  customerType,
  provinceId: address.ilId,
  districtId: address.ilceId,
  villageId: address.koyId
};
    try {
      await customerService.update({
        id,
        customer:payload
      });
      toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'Müşteri bilgileri güncellendi', life: 3000 });
      setTimeout(() => navigate("/customers"), 1500);
    } catch (err) {
      console.error(err);
      toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Güncelleme sırasında bir hata oluştu', life: 3000 });
    }
  };

  useEffect(() => {
    loadData();
  }, [id]);

  if (loading) return (
    <div className="flex flex-col items-center justify-center h-[80vh]">
      <i className="pi pi-spin pi-spinner text-4xl text-blue-600"></i>
      <p className="mt-3 text-gray-600">Müşteri bilgileri yükleniyor...</p>
    </div>
  );

  return (
    <div className="p-4">
      <Toast ref={toast}  appendTo={mounted ? document.body : "self"} />
<Card title={<div className="flex items-center gap-2 text-blue-600 uppercase text-sm font-bold">
  <i className="pi pi-user-edit"></i><span>Müşteri Düzenle</span></div>} className="shadow-md rounded-xl"

bu>
      
<div className="flex flex-column md:flex-row justify-content-between align-items-center mb-4 gap-3">
        <div>
         
        </div>
        <div className="flex gap-2">
          <Button label="Geri Dön" icon="pi pi-arrow-left" className="p-button-outlined p-button-secondary rounded-lg" onClick={() => navigate("/customers")} />
          <Button label="Değişiklikleri Kaydet" icon="pi pi-save" className="p-button-success rounded-lg px-4" onClick={handleSave} />
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        {/* SOL KOLON - GENEL VE İLETİŞİM */}
        <div className="lg:col-span-8">
          <Card
            title={<div className="flex items-center gap-2 text-blue-600 uppercase text-sm font-bold"><i className="pi pi-id-card"></i><span>Genel Bilgiler</span></div>}
            className="shadow-md rounded-xl mb-6 border-t-4 border-blue-600"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-3 p-fluid">
              <div className="md:col-span-2 mb-2">
                <label className="font-bold text-gray-900 mb-2 block text-sm">Müşteri Tipi</label>
                <SelectButton value={customerType} options={typeOptions} onChange={(e) => setCustomerType(e.value || "Bireysel")} unselectable={false} className="w-fit" />
              </div>

              <div>
                <label className="font-bold text-gray-900 mb-2 block text-sm">{customerType === 'Bireysel' ? 'Ad Soyad' : 'Şirket Ünvanı'}</label>
                <InputText value={customer.name} onChange={(e) => handleChange("name", e.target.value)} placeholder={customerType === 'Bireysel' ? 'Örn: Ahmet Yılmaz' : 'Örn: ABC Teknoloji A.Ş.'} />
              </div>

              <div>
                <label className="font-bold text-gray-900 mb-2 block text-sm">Müşteri No</label>
                <div className="p-inputgroup">
                  <span className="p-inputgroup-addon"><i className="pi pi-hashtag"></i></span>
                  <InputNumber value={customer.customerNumber} disabled />
                </div>
              </div>

              <div className="mt-1">
                <label className="font-bold text-gray-900 mb-2 block text-sm">E-Mail</label>
                <div className="p-inputgroup">
                  <span className="p-inputgroup-addon"><i className="pi pi-envelope"></i></span>
                  <InputText value={customer.email} onChange={(e) => handleChange("email", e.target.value)} />
                </div>
              </div>

              <div className="mt-1">
                <label className="font-bold text-gray-900 mb-2 block text-sm">Telefon</label>
                <div className="p-inputgroup">
                  <span className="p-inputgroup-addon"><i className="pi pi-phone"></i></span>
                  <InputMask value={customer.phone} onChange={(e) => handleChange("phone", e.target.value)} mask="(999) 999-9999" />
                </div>
              </div>

              {customerType === 'Kurumsal' && (
              <div className="mt-1">
                <label className="font-bold text-gray-900 mb-2 block text-sm">Yetkili Kişi</label>
                <InputText value={customer.authorizedPerson} onChange={(e) => handleChange("authorizedPerson", e.target.value)} />
              </div>
                   )}
            </div>
          </Card>

          <Card
            title={<div className="flex items-center gap-2 text-blue-600 uppercase text-sm font-bold"><i className="pi pi-map-marker"></i><span>Adres ve Notlar</span></div>}
            className="shadow-md rounded-xl mb-6"
          > 
          <div className="flex flex-col gap-4 p-fluid">
            <CustomerAddressSection
                             value={address}
                             onChange={(val) => setAddress(val)}
                          />
                          </div>
            <div className="grid grid-cols-1 md:grid-cols-2 mt-4 gap-4 p-fluid">
              <div className="md:col-span-2">
                <label className="font-bold text-gray-900 mb-2 block text-sm">Adres</label>
                <InputTextarea rows={3} value={customer.address} onChange={(e) => handleChange("address", e.target.value)} autoResize />
              </div>
              <div>
                <label className="font-bold text-gray-900 mb-2 block text-sm">Diğer Bilgiler</label>
                <InputTextarea rows={2} value={customer.otherInfo} onChange={(e) => handleChange("otherInfo", e.target.value)} autoResize />
              </div>
              <div>
                <label className="font-bold text-gray-900 mb-2 block text-sm">Not</label>
                <InputTextarea rows={2} value={customer.note} onChange={(e) => handleChange("note", e.target.value)} autoResize />
              </div>
            </div>
          </Card>
        </div>

        {/* SAĞ KOLON - CARİ BİLGİLER */}
        <div className="lg:col-span-4">
          <Card
            title={<div className="flex items-center gap-2 text-blue-600 uppercase text-sm font-bold"><i className="pi pi-money-bill"></i><span>Cari / Finans Bilgileri</span></div>}
            className="shadow-md rounded-xl border-t-4 border-blue-600"
          >
            <div className="flex flex-col gap-4 p-fluid">
              <div>
                <label className="font-bold text-gray-900 mb-2 block text-sm">{customerType === 'Bireysel' ? 'T.C. Kimlik No' : 'Vergi No'}</label>
                <InputText value={customer.taxNumber} onChange={(e) => handleChange("taxNumber", e.target.value)} maxLength={customerType === 'Bireysel' ? 11 : 10} />
              </div>

              {customerType === 2 && (
                <div>
                  <label className="font-bold text-gray-900 mb-2 block text-sm">Vergi Dairesi</label>
                  <InputText value={customer.taxOffice} onChange={(e) => handleChange("taxOffice", e.target.value)} />
                </div>
              )}

              <div>
                <label className="font-bold text-gray-900 mb-2 block text-sm">Açılış Bakiyesi</label>
                <div className="p-inputgroup">
                  <span className="p-inputgroup-addon">₺</span>
                  <InputNumber value={customer.openingBalance} onValueChange={(e) => handleChange("openingBalance", e.value)} mode="decimal" minFractionDigits={2} maxFractionDigits={2} />
                </div>
              </div>

              <div>
                <label className="font-bold text-gray-900 mb-2 block text-sm">Banka Bilgileri</label>
                <InputTextarea value={customer.bankInfo} onChange={(e) => handleChange("bankInfo", e.target.value)} autoResize />
              </div>

              <div>
                <label className="font-bold text-gray-900 mb-2 block text-sm">Sabit İskonto (%)</label>
                <div className="p-inputgroup">
                  <InputNumber value={customer.fixedDiscountRate} onValueChange={(e) => handleChange("fixedDiscountRate", e.value)} min={0} max={100} />
                  <span className="p-inputgroup-addon">%</span>
                </div>
              </div>

              <div className="mt-2">
                <div className="flex flex-col gap-3">
                  <div className="flex items-center gap-2 p-3 bg-gray-100 rounded-lg border border-gray-200">
                    <Checkbox inputId="taxExempt" checked={customer.isTaxExempt} onChange={(e) => handleChange("isTaxExempt", e.checked)} />
                    <label htmlFor="taxExempt" className="text-sm font-bold text-gray-700 cursor-pointer">Bu müşteri vergiden muaftır</label>
                  </div>

                  <div className={`flex items-center gap-2 p-3 rounded-lg border transition-colors ${customer.isActive ? 'bg-emerald-50 border-emerald-200' : 'bg-red-50 border-red-200'}`}>
                    <Checkbox inputId="isActive" checked={customer.isActive} onChange={(e) => handleChange("isActive", e.checked)} />
                    <label htmlFor="isActive" className={`text-sm font-bold cursor-pointer ${customer.isActive ? 'text-emerald-700' : 'text-red-700'}`}>
                      {customer.isActive ? 'Müşteri Aktif' : 'Müşteri Pasif'}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
      </Card>
    </div>
  );
}
